/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

let CLIENT_ID;
let ISSUER;

if (process.env.NODE_ENV === "development") {
    CLIENT_ID = process.env.CLIENT_ID || "0oadtd5o5gy5WkdYE1d7";
    ISSUER = "https://auth-preview.uspto.gov/oauth2/aus6xmp552J2eGev41d7";
} else {
    CLIENT_ID = process.env.CLIENT_ID || "0oa8uvkhzfTeKBdGJ4h7";
    ISSUER = "https://auth.uspto.gov/oauth2/aus4qv50b0BRaFZMp4h7";
}

const TOKEN_URL = ISSUER + "/v1/token";
const OKTA_TESTING_DISABLEHTTPSCHECK = process.env.OKTA_TESTING_DISABLEHTTPSCHECK || true;
const BASENAME = '/'; // BASENAME includes trailing slash
const REDIRECT_URI = `${window.location.origin}${BASENAME}callback`;

const config = {
    oidc: {
        clientId: CLIENT_ID,
        issuer: ISSUER,
        redirectUri: REDIRECT_URI,
        scopes: [
            'openid',
            'profile',
            'email'
        ],
        pkce: true,
        disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
        tokenUrl: TOKEN_URL
    },
    app: {
        basename: BASENAME,
    },
};

export default config;